/* global tinymce */
import { getDynamicDomainNameTemplate } from "../../shortcodes/templates";
import { CAPITALIZATION_VALUES, DOMAIN_TYPES } from "../../constants";

const dynamicDomainConfig = {
  title: "Dynamic Domain Config",
  body: {
    type: "panel",
    items: [
      {
        type: "listbox",
        name: "dynamicDomainType",
        label: "Select Dynamic Domain Type",
        disabled: false,
        items: [
          {
            text: "Full Domain Url: 'DomainName.com'",
            value: DOMAIN_TYPES.FULL_URL,
          },
          {
            text: "Domain Name Only: 'DomainName'",
            value: DOMAIN_TYPES.NAME_ONLY,
          },
        ],
      },
      {
        type: "listbox",
        name: "domainCase",
        label: "Capitalization",
        items: [
          {
            text: "Default (e.g. DomainName.com)",
            value: CAPITALIZATION_VALUES.DEFAULT,
          },
          {
            text: "lowercase (e.g. domainname.com)",
            value: CAPITALIZATION_VALUES.LOWER,
          },
          {
            text: "UPPERCASE (e.g. DOMAINNAME.COM)",
            value: CAPITALIZATION_VALUES.UPPER,
          },
        ],
      },
    ],
  },
  buttons: [
    {
      type: "cancel",
      name: "closeButton",
      text: "Cancel",
    },
    {
      type: "submit",
      name: "submitButton",
      text: "Insert",
      primary: true,
    },
  ],
  onSubmit: function (api) {
    const data = api.getData();
    tinymce.activeEditor.execCommand(
      "mceInsertContent",
      false,
      getDynamicDomainNameTemplate(data.dynamicDomainType, data.domainCase),
    );
    api.close();
  },
};

export { dynamicDomainConfig };
